import Button from "components/button";
import { ModalConfirmAction } from "components/modal-confirm-action";
import { useState } from "react";
import intl from "react-intl-universal";
import { FooterContainer } from "./styled";
import { IGridParameterizationFooterProps } from "../../types";

const GridParameterizationFooter = ({
  handleCancel,
  handleSave,
  disabledSave,
}: IGridParameterizationFooterProps) => {
  const [modalData, setModalData] = useState({
    isOpen: false,
    actionType: "",
    title: "",
    textMessage: "",
  });

  const handleCloseModal = () =>
    setModalData({
      isOpen: false,
      actionType: "",
      title: "",
      textMessage: "",
    });

  const triggerActionConfirmationModal = (actionType: string) => {
    setModalData({
      isOpen: true,
      actionType: actionType,
      title:
        actionType === "save"
          ? intl.get("geral.buttonsDefault.saveChanges")
          : intl.get("commons.discard-changes"),
      textMessage:
        actionType === "save"
          ? intl.get("commons.do-you-want-save-the-changes")
          : intl.get("commons.are-you-sure-you-want-to-discard-the-changes"),
    });
  };

  const handleConfirmAction = (actionType: string) => {
    actionType === "save" ? handleSave() : handleCancel();
    handleCloseModal();
  };

  return (
    <>
      <FooterContainer>
        <Button
          value={intl.get("geral.buttonsDefault.cancel")}
          onClick={() => triggerActionConfirmationModal("cancel")}
          className="grid-parameterization-button-cancel"
          disabled={disabledSave}
        />
        <Button
          value={intl.get("geral.buttonsDefault.save")}
          onClick={() => triggerActionConfirmationModal("save")}
          buttonType="tertiary"
          disabled={disabledSave}
          style={{
            minWidth: "fit-content",
            width: "112px",
            height: "28px",
            fontSize: "12px",
            padding: "0 1.4rem",
          }}
        />
      </FooterContainer>

      {modalData.isOpen && (
        <ModalConfirmAction
          isOpen={modalData.isOpen}
          key={modalData.actionType}
          handleClose={handleCloseModal}
          title={modalData.title}
          textMessage={modalData.textMessage}
          handleConfirm={() => handleConfirmAction(modalData.actionType)}
          showIconCloseButton={true}
        />
      )}
    </>
  );
};

export default GridParameterizationFooter;
